import React from 'react';
import Icon from './Icon';

export default class IconDelete extends Icon {

    renderIcon() {
        const color = this.props.color ? this.props.color : (this.state.hover ? '#ec6b05' : '#A6ACAF')
        return (
            <svg width={this.getSize()} height={this.getSize()} viewBox="0 0 9 8">
                <path fill={color} fillRule="nonzero"
                      d="M4.772 5.468L2.134 8.106.772 6.744l2.639-2.638L.772 1.468 2.134.106l2.638 2.638L7.411.106l1.361 1.362-2.638 2.638 2.638 2.638-1.361 1.362-2.639-2.638z"/>
            </svg>
        )
    }
}